import type { TeamInvitationData, TeamMemberData } from '../../types/n8nResponses';

export const getTeamAccessStatus = (member: Pick<TeamMemberData | TeamInvitationData, 'status' | 'access_status'>) => {
  const preference = member.access_status?.trim().toLowerCase();
  if (preference === 'blocked') return 'Blocked';
  if (preference === 'invited' || member.status === 'pending') return 'Invited';
  if (preference === 'active') return 'Active';
  if (preference === 'inactive') return 'Inactive';
  return member.status === 'accepted' ? 'Joined' : 'Unknown';
};

export const teamAccessTone = (status: string) => status === 'Invited'
  ? 'border-amber-400/20 bg-amber-400/10 text-amber-100'
  : status === 'Blocked'
    ? 'border-rose-400/20 bg-rose-400/10 text-rose-100'
    : status === 'Active'
      ? 'border-emerald-400/20 bg-emerald-400/10 text-emerald-100'
      : 'border-white/10 bg-white/5 text-white/75';
